var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBentomenu1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menus/bento menu-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3.96C3 3.62397 3 3.45595 3.0654 3.32761C3.12292 3.21471 3.21471 3.12292 3.32761 3.0654C3.45595 3 3.62397 3 3.96 3H6.84C7.17603 3 7.34405 3 7.47239 3.0654C7.58529 3.12292 7.67708 3.21471 7.7346 3.32761C7.8 3.45595 7.8 3.62397 7.8 3.96V6.84C7.8 7.17603 7.8 7.34405 7.7346 7.47239C7.67708 7.58529 7.58529 7.67708 7.47239 7.7346C7.34405 7.8 7.17603 7.8 6.84 7.8H3.96C3.62397 7.8 3.45595 7.8 3.32761 7.7346C3.21471 7.67708 3.12292 7.58529 3.0654 7.47239C3 7.34405 3 7.17603 3 6.84V3.96Z",
    stroke: "#858C95",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11.16C3 10.824 3 10.656 3.0654 10.5276C3.12292 10.4147 3.21471 10.3229 3.32761 10.2654C3.45595 10.2 3.62397 10.2 3.96 10.2H6.84C7.17603 10.2 7.34405 10.2 7.47239 10.2654C7.58529 10.3229 7.67708 10.4147 7.7346 10.5276C7.8 10.656 7.8 10.824 7.8 11.16V14.04C7.8 14.376 7.8 14.544 7.7346 14.6724C7.67708 14.7853 7.58529 14.8771 7.47239 14.9346C7.34405 15 7.17603 15 6.84 15H3.96C3.62397 15 3.45595 15 3.32761 14.9346C3.21471 14.8771 3.12292 14.7853 3.0654 14.6724C3 14.544 3 14.376 3 14.04V11.16Z",
    stroke: "#858C95",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 3.96C10.2 3.62397 10.2 3.45595 10.2654 3.32761C10.3229 3.21471 10.4147 3.12292 10.5276 3.0654C10.656 3 10.824 3 11.16 3H14.04C14.376 3 14.544 3 14.6724 3.0654C14.7853 3.12292 14.8771 3.21471 14.9346 3.32761C15 3.45595 15 3.62397 15 3.96V6.84C15 7.17603 15 7.34405 14.9346 7.47239C14.8771 7.58529 14.7853 7.67708 14.6724 7.7346C14.544 7.8 14.376 7.8 14.04 7.8H11.16C10.824 7.8 10.656 7.8 10.5276 7.7346C10.4147 7.67708 10.3229 7.58529 10.2654 7.47239C10.2 7.34405 10.2 7.17603 10.2 6.84V3.96Z",
    stroke: "#858C95",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2 11.16C10.2 10.824 10.2 10.656 10.2654 10.5276C10.3229 10.4147 10.4147 10.3229 10.5276 10.2654C10.656 10.2 10.824 10.2 11.16 10.2H14.04C14.376 10.2 14.544 10.2 14.6724 10.2654C14.7853 10.3229 14.8771 10.4147 14.9346 10.5276C15 10.656 15 10.824 15 11.16V14.04C15 14.376 15 14.544 14.9346 14.6724C14.8771 14.7853 14.7853 14.8771 14.6724 14.9346C14.544 15 14.376 15 14.04 15H11.16C10.824 15 10.656 15 10.5276 14.9346C10.4147 14.8771 10.3229 14.7853 10.2654 14.6724C10.2 14.544 10.2 14.376 10.2 14.04V11.16Z",
    stroke: "#858C95",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBentomenu1);
export default __webpack_public_path__ + "static/media/bento menu-1.baaf3268f1a20149324d272b28b9b568.svg";
export { ForwardRef as ReactComponent };